import { render, staticRenderFns } from "./fornecedor-detalhe.vue?vue&type=template&id=121e1a7a"
import script from "./fornecedor-detalhe.vue?vue&type=script&lang=js"
export * from "./fornecedor-detalhe.vue?vue&type=script&lang=js"
import style0 from "./fornecedor-detalhe.vue?vue&type=style&index=0&id=121e1a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports